export default __webpack_public_path__ + "static/media/paradigma_logo.badd6760.png";